module.exports = __webpack_public_path__ + "img/logo.01dd1cf5.png";